module.exports = __webpack_public_path__ + "img/柳川吊腳樓一景.5a1a85ee.jpg";